import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const mapSearchSchema = z.object({
  style: z
    .enum([
      'explore',
      'night',
      'logistics',
      'logisticsNight',
      'satellite',
      'terrain',
    ])
    .optional(),
  layers: z.string().optional(),
  edit: z.coerce.number().optional(),
  fromTemplate: z.coerce.number().optional(),
})

// Calculate-route was merged into the routes page (Calculate tab). Redirect old
// links/bookmarks, carrying over edit/fromTemplate/style/layers.
export const Route = createFileRoute('/dashboard/calculate-route/')({
  validateSearch: mapSearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/dashboard/routes',
      search: { ...search, tab: 'calculate' },
    })
  },
})
